<div class="tab-pane mi-auto" id="menu4">
    <div class="row" *ngIf='loader'>
        <app-sura-loader></app-sura-loader>
    </div>
    <div class="row" *ngIf="!loader">
        <div class="col-xs-12">
            <div class="box-title col-xs-12">
                <h3>Última actualización:<strong id="cicloViajes"> {{ ultimaActualizacion }}</strong></h3>
            </div>
        </div>
        <div *ngIf='noData'>
            <div class="col-xs-12">
                <div class="box-center">
                    <div class="box-fecha__text">
                        <p>No hay alertas de problemas abiertas para este vehículo</p>
                    </div>
                </div>
            </div>
            <div class="col-xs-12">
                <div class="box-icon"><img src="../../../assets/img/sura-icon-auto.svg" alt="SURA ICON AUTO" />
                    <p><strong>¡Felicidades! Sigue cuidando de buena forma tu auto.</strong></p>
                </div>
            </div>
        </div>
        <div *ngIf='!noData'>
            <app-menu-auto [listGroupEvent]='listGroupEvent'></app-menu-auto>
        </div>
    </div>
</div>
